import { useMiscDraftProgressivePromosStore } from '~/stores/miscDraftProgressivePromos'

/**
 * Fetches and checks promotional code related data. **This uses useLazyAsyncData** so always place this above onMounted calls.
 */
export function useProgressivePromosCheck() {
  const { $pinia } = useNuxtApp()
  const { FETCH: FETCH_PROMOS } = useMiscDraftProgressivePromosStore($pinia)

  return callOnce('FETCH_PROMOS', FETCH_PROMOS, { mode: 'navigation' })
}
